import React from 'react';

import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import JobVaultShowPageContainer from 'buyside/components/container/JobVaultShow/JobVaultShowPageContainer';

const JobVaultShowPageRoot = ({ jobPostId }) => {
  if (!jobPostId) return;
  return (
    <ErrorBoundary pageName="the job">
      <JobVaultShowPageContainer jobPostId={jobPostId} />
    </ErrorBoundary>
  );
};

export default JobVaultShowPageRoot;
